import { useTranslation } from 'react-i18next';
import { CtaLink, GalleryPage } from '../shared/GalleryPage';

export default function Confirmation() {
  const { t } = useTranslation();

  return (
    <GalleryPage
      eyebrow={t('Thank you for your order')}
      title={t('Go create something awesome!')}
      subtitle={t(
        'Your products are ready for download. We will send you an email with all the necessary instructions.',
      )}
    >
      {window.MYCHAOS && (
        <>
          <CtaLink href={`${window.MYCHAOS}/download`}>{t('Download')}</CtaLink>
          <CtaLink href={window.MYCHAOS} variant="outline">
            {t('Go to admin dashboard')}
          </CtaLink>
        </>
      )}
    </GalleryPage>
  );
}
